import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
export function Footer() {
 const {t}=useLanguage();
 return <footer className="site-footer site-footer-expanded">
  <div className="footer-brand"><img alt="J’aime Fine Jewellery" src="/assets/images/brand-wordmark-clean.png"/><p>{t('footerLocation','Victoria, British Columbia')}</p></div>
  <nav aria-label={t('ariaCustomerInfo','Customer information')} className="footer-links">
   <Link to="/private-enquiry.html">{t('footerEnquiry','Private Enquiry')}</Link><Link to="/shipping-returns.html">{t('footerShipping','Shipping & Returns')}</Link>
   <Link to="/privacy.html">{t('footerPrivacy','Privacy')}</Link><Link to="/intellectual-property.html">{t('footerIP','Intellectual Property')}</Link><Link to="/terms.html">{t('footerTerms','Terms')}</Link>
  </nav>
  <p className="footer-copyright">{t('footerCopyright','© 2026 J’AIME FINE JEWELLERY LTD. All rights reserved.')}</p>
  <p className="footer-ip-notice">{t('footerIpNotice','Original jewellery designs, packaging designs, drawings, renderings, photographs and website content may not be copied, reproduced, manufactured or used commercially without prior written permission.')}</p>
 </footer>;
}
